import React from 'react';
import { useParams } from 'react-router-dom';
import NotFound from '../NotFound/NotFound';
import { useFetchTestMedia } from '../../service/test-media/useFetchTestMedia';
import { SuspenseWrapper } from './SuspenseWrapper';

function TestPlayerRoute() {
  const { testId: testIndexStr } = useParams();
  const testIndex = testIndexStr ? Number.parseInt(testIndexStr) : null;

  const { data, isLoading } = useFetchTestMedia();

  if (testIndex === null || (!isLoading && !data?.[testIndex]))
    return <NotFound />;

  return (
    <SuspenseWrapper isLoading={isLoading}>
      <TestPlayer test={data?.[testIndex]} />
    </SuspenseWrapper>
  );
}

const TestPlayer = React.lazy(() => import('../TestView/TestPlayerContainer'));

export default TestPlayerRoute;
